import React, { useEffect, useRef } from 'react';

type CombinedRef<T> = React.RefCallback<T> | React.MutableRefObject<T> | null;

export const useCombinedRef = <T>(...refs: CombinedRef<T | null>[]): CombinedRef<T | null> => {
    const targetRef = useRef<T | null>(null);

    useEffect(() => {
        refs.forEach((ref) => {
            if (ref === null) return;

            if (typeof ref === 'function') {
                ref(targetRef.current);
            } else {
                ref.current = targetRef.current;
            }
        });
    }, [refs]);

    return targetRef;
};
